import { create } from "zustand";
import { initialState, RIGStore } from "./RIG.state";
import { createRIGActions } from "./RIG.actions";

/**
 * State management store for the Reader Intelligence Guide
 * @example
 * ```
 * const dispatch = useRIGStore((state) => state.dispatch)
 * dispatch({ type: RIGActions.SET_DISCLOSURE_RIGS, payload: NormalizedDisclosureRIG[] })
 * ```
 */
export const useRIGStore = create<RIGStore>((set, get) => ({
    ...initialState,
    ...createRIGActions(set, get),
}));
